var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"frv2-d-btn-group"},[(_vm.alignRight)?_c('div',{staticClass:"frv2-d-btn-group-right"}):_vm._e(),_vm._t("default"),(!_vm.alignRight)?_c('div',{staticClass:"frv2-d-btn-group-left"}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }